import { html, type TemplateResult } from "lit";
import type { MockEvent } from "../data/mock-events";

export function renderProgramSessionList(event: MockEvent): TemplateResult {
  const sessions = event.program?.sessions ?? [];
  return html`<ol aria-label="Program sessions">
    ${sessions.map(
      (session) =>
        html`<li>
          <strong>${session.label}</strong>
          <span>
            ${new Intl.DateTimeFormat(undefined, {
              dateStyle: "medium",
              timeStyle: "short",
            }).format(new Date(session.startsAt))}
            ${session.locationName ? ` · ${session.locationName}` : ""}
          </span>
        </li>`,
    )}
  </ol>`;
}

export function programCheckoutSubtitle(event: MockEvent): string {
  const sessions = event.program?.sessions ?? [];
  const locations = [
    ...new Set(
      sessions
        .map(({ locationName }) => locationName)
        .filter((name): name is string => !!name),
    ),
  ];
  return `${sessions.length} session${sessions.length === 1 ? "" : "s"}${
    locations.length ? ` · ${locations.join(", ")}` : ""
  }`;
}
